'use strict'

import moment from 'moment'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

const _momentUtc = (momentDate, userUtcOffset) => {
  return moment.utc(momentDate).utcOffset(userUtcOffset)
}

const _formatMomentUtc = (momentDate, format, userUtcOffset) => {
  return _momentUtc(momentDate, userUtcOffset).format(format)
}

export default {
  filters: {
    formatDate (datetime, utcOffset) {
      return _formatMomentUtc(datetime, 'DD.MM.YYYY', utcOffset)
    },
    formatTime (datetime, utcOffset) {
      return _formatMomentUtc(datetime, 'HH:mm:ss', utcOffset)
    },
    formatDatetime (datetime, utcOffset) {
      return _formatMomentUtc(datetime, 'DD.MM.YYYY HH:mm', utcOffset)
    },
    formatMonthYear (datetime, utcOffset) {
      return _formatMomentUtc(datetime, 'MMMM YYYY', utcOffset)
    },
    formatMonth (datetime, utcOffset) {
      return _formatMomentUtc(datetime, 'MMMM', utcOffset)
    }
  },
  computed: {
    ...mapState({
      dateFrom: state => state.time.dateFrom,
      dateTo: state => state.time.dateTo,
      aggregationMode: state => state.time.aggregationMode,
      events: state => state.time.events,
      selectedTimelineId: state => state.time.selectedTimelineId,
      userUtcOffset: state => state.time.userUtcOffset,
      frameSize: state => state.time.frameSize
    }),
    ...mapGetters([
      'timelines',
      'aggregationModeFromFrameSize',
      'timeUserUTCOffset',
      'timeUserUTCOffsetTimestamp',
      'timeUserUTCOffsetTimestampPlotly',
      'utcOffsetDisplay',
      'availableHydrologicalYears',
      'currentHydrologicalYear',
      'firstValueDate',
      'lastValueDate',
      'dateMiddle'
    ])
  },
  methods: {
    ...mapMutations([
      'setEvents',
      'addEvents',
      'removeEvents',
      'cleanEvents',
      'setSelectedTimelineId',
      'setAggregationMode',
      'setCurrentHydrologicalYear',
      'setTimeframe'
    ]),
    ...mapActions([
      'updateTimeframeForLayer'
    ]),
    momentUtc (momentDate) {
      return moment.utc(momentDate).utcOffset(this.userUtcOffset)
    },
    // Hack: Format par défaut sans timezone, pour pouvoir l'utiliser dans plotly
    formatMomentUtc (momentDate, format = 'YYYY-MM-DDTHH:mm:ss.000') {
      return this.momentUtc(momentDate).format(format)
    },
    getHydrologicalYears (year) {
      let dateTo = moment.utc().set('year', year).set('date', 30).set('month', 8).set('hour', 0).set('minute', 0).set('second', 0)
      let dateFrom = moment.utc(dateTo).subtract(1, 'years').set('date', 1).set('month', 9)
      return [dateFrom, dateTo]
    },
    getHalfWindowSizeFromTimeResolution (timeResolution) {
      switch (timeResolution) {
        case 'MM':
        default:
          return moment.duration(6, 'months')
      }
    }
  }
}
